import * as React from 'react';

import PayrollPage from './PayrollPage';

// Monthly Changes lives as a tab of the Payroll page; this route (e.g. Home "pay changes to review")
// opens Payroll directly on that tab.
export default function MonthlyChangesPage(): React.JSX.Element {
    return <PayrollPage initialTab="changes"/>;
}
